import { useEffect, useState } from 'react'

import { RECAPTCHA_KEY, BUILD_ENV } from 'gatsby-env-variables'

import { datadog } from '@itau-loans-www/services'

import showFeedback from '../useFeedback'
import useReCAPTCHAEnterprise from '../useReCAPTCHAEnterprise'

const DEFAULT_ACTION = 'lead_start'

const useRecaptcha = (setIsLoading, setButtonLoading) => {
  const { getToken } = useReCAPTCHAEnterprise(RECAPTCHA_KEY, DEFAULT_ACTION)
  const [isToGetRecaptcha, setIsToGetRecaptcha] = useState(true)

  const getRecaptcha = async () => {
    if (isToGetRecaptcha) {
      try {
        const token = await getToken()
        return token
      } catch (error) {
        return onRecaptchaFailure()
      }
    }
  }

  const onRecaptchaFailure = (error = 'Falha na Autenticação Recaptcha') => {
    showFeedback({
      detail: {
        show: true,
        type: 'error',
        message: error
      }
    })

    setIsLoading(false)
    setButtonLoading(false)

    datadog.logsError.recaptchaError(error)

    throw new Error(error)
  }

  useEffect(() => {
    if (['e2e', 'development', 'staging'].includes(BUILD_ENV)) {
      setIsToGetRecaptcha(false)
    }
  }, [])

  return {
    getRecaptcha
  }
}

export default useRecaptcha
